import { ExternalLink } from "lucide-react";
import { MARKET } from "@/lib/marketplaces";

export function BuyLink({ k, testid, full = false, className = "" }) {
  const m = MARKET[k];
  if (!m) return null;
  return (
    <a href={m.url} target="_blank" rel="noopener noreferrer" data-testid={testid}
      className={`inline-flex items-center justify-center gap-1.5 rounded-full text-sm transition-[transform,background-color,border-color] duration-200 hover:-translate-y-0.5 ${full ? "ember-btn w-full py-3" : "px-4 py-1.5 border border-amber-400/50 text-amber-200 hover:bg-amber-500/10"} ${className}`}>
      {full ? `Buy on ${m.name}` : "Buy"} <ExternalLink className="w-3.5 h-3.5" />
    </a>
  );
}
